import React from "react";
import { AlertTriangle, ShieldCheck } from "lucide-react";

/**
 * Legal disclaimer shown across the whole app.
 * Three visual variants:
 *   - "compact"  : slim inline pill (for headers, splash CTA, product cards)
 *   - "banner"   : full-width neon banner (top of catalog, above marquee)
 *   - "strong"   : boxed high-visibility block (checkout, before order submit)
 */
const DISCLAIMER_TEXT_FULL =
    "Sito puramente dimostrativo. Nessun prodotto è realmente in vendita. Tutti i contenuti (foto, video, descrizioni, prezzi) hanno scopo esclusivamente illustrativo. Il sito rispetta integralmente tutte le normative vigenti.";
const DISCLAIMER_TEXT_SHORT =
    "Sito dimostrativo — nessun prodotto in vendita. Contenuti a solo scopo illustrativo. Conforme alle normative vigenti.";

export const LegalDisclaimer = ({ variant = "compact", className = "" }) => {
    if (variant === "banner") {
        return (
            <div
                data-testid="legal-disclaimer-banner"
                className={
                    "w-full px-4 py-2.5 bg-[#1a0b2e]/85 border-y border-[#e879f9]/40 backdrop-blur-sm " +
                    className
                }
            >
                <div className="max-w-5xl mx-auto flex items-start sm:items-center gap-2.5 text-center sm:text-left justify-center">
                    <AlertTriangle className="w-4 h-4 shrink-0 text-amber-300 drop-shadow-[0_0_6px_rgba(252,211,77,0.5)] mt-0.5 sm:mt-0" />
                    <p className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.14em] leading-relaxed text-white/80">
                        <span className="text-amber-300 font-bold">Sito dimostrativo</span>
                        {" — "}
                        Nessun prodotto in vendita. Contenuti a solo scopo illustrativo.
                        {" "}
                        <span className="text-[#e879f9]">Conforme alle normative vigenti.</span>
                    </p>
                </div>
            </div>
        );
    }

    if (variant === "strong") {
        return (
            <div
                data-testid="legal-disclaimer-strong"
                className={
                    "flex items-start gap-2.5 p-3 rounded-2xl border border-amber-400/60 bg-amber-500/10 " +
                    className
                }
            >
                <AlertTriangle className="w-5 h-5 shrink-0 text-amber-300 mt-0.5" />
                <div className="text-[11px] leading-relaxed text-amber-100/95">
                    <div className="font-mono uppercase tracking-widest text-amber-300 text-[10px] font-bold mb-1">
                        Avviso legale
                    </div>
                    {DISCLAIMER_TEXT_FULL}
                </div>
            </div>
        );
    }

    // Default: compact pill
    return (
        <div
            data-testid="legal-disclaimer-compact"
            className={
                "inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-amber-400/40 bg-amber-500/10 " +
                className
            }
        >
            <ShieldCheck className="w-3 h-3 text-amber-300 shrink-0" />
            <span className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.14em] text-amber-100/90 leading-tight">
                {DISCLAIMER_TEXT_SHORT}
            </span>
        </div>
    );
};

export default LegalDisclaimer;
